/**
 * Cookie consent card: asks Shopify's Customer Privacy API whether this
 * visitor still needs asking, shows the card if so, and records their answer.
 * It only appears on the first page a visitor sees: once shown, it stays away
 * on later pages whether or not they answered. Without an answer Shopify
 * treats the visitor as not consenting, so nothing is tracked.
 */
(() => {
  const banner = document.querySelector('[data-cookie-banner]');
  if (!banner || !window.Shopify?.loadFeatures) return;

  const SEEN_KEY = 'fem-cookie-banner-seen';
  const wasSeen = () => {
    try {
      return localStorage.getItem(SEEN_KEY) === '1';
    } catch {
      return false;
    }
  };
  const markSeen = () => {
    try {
      localStorage.setItem(SEEN_KEY, '1');
    } catch {}
  };

  if (wasSeen()) return;

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    const privacy = window.Shopify.customerPrivacy;
    if (error || !privacy || !privacy.shouldShowBanner()) return;

    const answer = (granted) => {
      privacy.setTrackingConsent(
        { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted },
        () => {}
      );
      banner.classList.add('is-leaving');
      setTimeout(() => (banner.hidden = true), 250);
    };

    banner.querySelector('[data-cookie-accept]').addEventListener('click', () => answer(true));
    banner.querySelector('[data-cookie-decline]').addEventListener('click', () => answer(false));
    banner.hidden = false;
    markSeen();
  });
})();
